import { render, staticRenderFns } from "./periscope.vue?vue&type=template&id=4395a50c"
import script from "./periscope.vue?vue&type=script&lang=js"
export * from "./periscope.vue?vue&type=script&lang=js"
import style0 from "./periscope.vue?vue&type=style&index=0&id=4395a50c&prod&lang=css"
import style1 from "./periscope.vue?vue&type=style&index=1&id=4395a50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports